
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React, { useEffect } from 'react';
import Head from 'next/head';
import type { NextPage } from 'next';
import TopcoPageHistory from '@src/lib/utils/topcoPageHistory';
import dynamic from 'next/dynamic';
import { isRefererCheck } from '@src/lib/utils/utils';
import { useRouter } from 'next/router';
import { TopcoPartner } from '@src/lib/marketing/TopcoPartner';
import SeoComponent from '@src/view/common/seo/SeoCompnent';

const HomeComponent = dynamic<any>(
  () => import('@src/view/components/home/HomeComponent'),
  { ssr: false },
);

const Home: NextPage = (props: any) => {
  const { isReferer } = props;
  const router = useRouter();

  useEffect(() => {
    if (!isReferer) {
      TopcoPageHistory.getInstance().clear();
      TopcoPageHistory.getInstance().setter({
        path: router.asPath,
        scroll: window.scrollY,
        fix: '',
      });
    }
  }, [isReferer]);

  return (
    <>
      <Head>
        <link rel="manifest" href="/favicon/manifest.json" />
      </Head>
      <SeoComponent.Main />
      <HomeComponent />
    </>
  );
};

 async function _getServerSideProps(context: any) {
  const isReferer: boolean = isRefererCheck(context);

  await TopcoPartner.setterSSR(context);

  return {
    props: {
      isReferer,
    },
  };
}

export default Home;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  